import { render } from "./Datemanager.vue?vue&type=template&id=1108210a&scoped=true&ts=true"
import script from "./Datemanager.vue?vue&type=script&lang=ts"
export * from "./Datemanager.vue?vue&type=script&lang=ts"

import "./Datemanager.vue?vue&type=style&index=0&id=1108210a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1108210a"]])

export default __exports__